import { IDropdownStyles, IStyle } from '@fluentui/react';

export interface IGPTeOverallDataStyles {
  root: IStyle;
  gridContainer: IStyle;
  tableContainer: IStyle;
  dropdowns: IStyle;
  lineChartWrapper: IStyle;
}

export const gpteOverallDataStylesDefault = (): Partial<IGPTeOverallDataStyles> => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '2rem',
    marginTop: '1rem',
  },
  tableContainer: {
    marginTop: '2rem',
  },
  dropdowns: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  lineChartWrapper: {
    width: '80%',
    maxWidth: '100%',
    margin: '0 auto',
  },
});

export const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: '100%',
    maxWidth: 400,
    minWidth: 200,
  },
  dropdownItemsWrapper: {
    maxWidth: 400,
    maxHeight: 300,
  },
};
